import React from 'react';

const CustomizeDescriptionBox = () => (
  <div className="customize-description-box">
    <div className="filename-template-heading">Customize your filename format below</div>
    <div className="filename-template-heading2">
      Click “edit” in either the Folder or Filename box to edit configurations for that setting.
      <br />
      Select fields on the left to add them to your configuration.  Click Save at the bottom when done.
    </div>
  </div>
);

export default CustomizeDescriptionBox;



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/CustomizeDescriptionBox.jsx